import React, { useEffect, useState } from 'react'
import Select, { components } from 'react-select'
import { models } from './models'
import icons from '../../../assets/icons'

const customStyles = (width, bg, border, fontWeight) => ( {
  control: () => ({
    width: width || '260px',
    height: '50px',
    display: 'flex',
    position: 'relative',
    border: border || '3px solid rgba(188, 224, 253, 1)',
    borderRadius: '10px',
    color: 'rgba(0,0,0,1)',
    paddingLeft: '9px',
    background: bg,
  }),
  singleValue: ()=>({
    color: 'black',
    fontWeight: fontWeight

  }),
  placeholder: () => ({
    color: 'black',
    fontSize: '16px',
    fontWeight: fontWeight || 'bold'
  }),
  indicatorSeparator: () => ({
    width: 0
  }),

  menu: () => ({
    width: width || '260px',
    background: 'white',
    border: '3px solid rgba(188, 224, 253, 1)',
    borderRadius: '10px',
    marginTop: '5px',
    position: 'absolute',
    fontWeight: 'normal',
    zIndex: 111

  }),

  menuList: () => ({
    padding: 0,
    background: 'white',
    borderRadius: '10px'

  }),
  option: () => ({
    '&:first-child': {
      borderTop: '0'
    },
    fontWeight: 'normal',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    paddingLeft: '20px',
    '&:hover': {
      background: 'rgba(244, 247, 254, 1)'
    },
    borderTop: '1px solid rgba(39, 139, 154, 0.2)'

  })
})
const mobileStyles = {

  control: () => ({
    width: '260px',
    height: '35px',
    display: 'flex',
    position: 'relative',
    fontSize: '15px',
    border: '3px solid rgba(188, 224, 253, 1)',
    borderRadius: '10px',
    color: 'black',
    paddingLeft: '9px'

  }),
  indicatorSeparator: () => ({
    width: 0
  }),

  placeholder: () => ({
    color: 'black',
    fontSize: '15px',
    fontWeight: 'bold'
  }),
  singleValue: ()=>({
    color: 'black'
  }),
  menu: () => ({
    width: '260px',
    background: 'white',
    fontSize: '15px',
    border: '3px solid rgba(188, 224, 253, 1)',
    borderRadius: '10px',
    marginTop: '15px',
    position: 'absolute',
    fontWeight: 'normal',
    zIndex: 111
  }),
  option: () => ({
    '&:first-child': { borderTop: '0' },
    fontWeight: 'normal',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    paddingLeft: '20px',
    '&:hover': {
      background: 'rgba(244, 247, 254, 1)'
    },
    borderTop: '1px solid rgba(39, 139, 154, 0.2)'

  })
}


function MainSelect(props) {
  const [mobile, setMobile] = useState()
  window.addEventListener('resize', _ => {
    setMobile(window.innerWidth <= 1100)
  })

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <img width={'15px'} height={'15px'} src={icons.arrowDown} alt='drop' />
      </components.DropdownIndicator>
    )
  }

  const IndicatorsContainer = props => {
    return <components.IndicatorsContainer {...props}>
      <div style={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        paddingRight: '9px'
      }}>
        {props.children}
      </div>
    </components.IndicatorsContainer>
  }


  useEffect(() => {
    setMobile(window.innerWidth <= 1100)
  }, [])

  return (
    <Select onKeyPress={props.onKeyPress}
            components={{ DropdownIndicator, IndicatorsContainer }}
            value={props.value}
            isSearchable={false}
            placeholder={props.placeholder}
            isClearable={false}
            onChange={props.onChange}
            className={'react-select-container'}
            namePrefix={'react-select'}
            styles={mobile ? mobileStyles : customStyles(props.width, props.bg, props.border, props.fontWeight)}
            width={props.width || '200px'}
            options={props.type ? models(props.type): props.options} />
  )
}

export default MainSelect